exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{height:100%}.topbar-px-logo{background:url(" + require("../img/my-payex-logo.svg") + ") no-repeat!important;background-size:130px!important;width:130px!important;visibility:visible}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/app.css
 ** module id = 384
 ** module chunks = 0
 **/